module.exports = __webpack_public_path__ + "img/performing.28c91e2.png";